import { HcSubscriptionPlanType } from './hc-subscription.model';

/**
 * Billing History Model
 * Tracks all billing transactions for health check subscriptions
 */
export interface HcBillingHistory {
  _id: string;
  csId: string; // Care seeker ID
  subscriptionId?: string; // Reference to HcSubscription._id (if applicable)
  planType: HcSubscriptionPlanType; // Plan type at time of charge
  billingType: HcBillingType; // Type of billing transaction
  amount: number; // Amount charged in dollars
  refundAmount?: number; // Refund amount in dollars (e.g. for cancellations with prorated refund)
  currency: string; // Currency code (default: 'cad')
  status: HcBillingStatus; // Payment status
  stripeInvoiceId?: string; // Stripe invoice ID (for recurring subscriptions)
  stripePaymentIntentId?: string; // Stripe payment intent ID (for per-call charges)
  stripeChargeId?: string; // Stripe charge ID
  stripeSubscriptionId?: string; // Stripe subscription ID (for recurring billing)
  description: string; // Description of the charge
  billingPeriodStart?: Date; // Start of billing period (for recurring subscriptions)
  billingPeriodEnd?: Date; // End of billing period (for recurring subscriptions)
  paidAt?: Date; // When payment was completed
  failedAt?: Date; // When payment failed (if applicable)
  failureReason?: string; // Reason for payment failure
  metadata?: Record<string, unknown>; // Additional metadata
  createdAt: Date;
  updatedAt: Date;
}

export enum HcBillingType {
  SUBSCRIPTION_RENEWAL = 'HcBillingType.subscriptionRenewal', // Recurring subscription charge
  SUBSCRIPTION_INITIAL = 'HcBillingType.subscriptionInitial', // Initial subscription purchase
  PER_CALL_CHARGE = 'HcBillingType.perCallCharge', // Per-call charge for pay-as-you-go
  EMERGENCY_CALL_CHARGE = 'HcBillingType.emergencyCallCharge', // Emergency call charge
  PRORATION = 'HcBillingType.proration', // Prorated charge for plan changes
  REFUND = 'HcBillingType.refund', // Refund
  CANCELLATION = 'HcBillingType.cancellation', // Subscription cancellation
}

export enum HcBillingStatus {
  PENDING = 'HcBillingStatus.pending', // Payment pending
  PAID = 'HcBillingStatus.paid', // Payment succeeded
  FAILED = 'HcBillingStatus.failed', // Payment failed
  REFUNDED = 'HcBillingStatus.refunded', // Payment refunded
  VOID = 'HcBillingStatus.void', // Invoice voided
}

